export let isAndroid = typeof Android != 'undefined'